const units = ['B', 'kB', 'MB', 'GB', 'TB', 'PB']

export default {
  methods: {
    asBytes (bytes, precision) {
      if (bytes === 0) { return '0 B' }
      if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) { return '-' }
      if (typeof precision === 'undefined') { precision = 1 }
      let number = Math.floor(Math.log(Math.abs(bytes)) / Math.log(1024))
      return (bytes / Math.pow(1024, Math.floor(number))).toFixed(precision) + ' ' + units[number]
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/shared/asBytes.js